import MainGetInTouch from "../components/get-in-touch/main-get-in-touch";

export default function GetInTouchQueriesPage() {
  return <MainGetInTouch />;
}
